module.exports = [
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-14-61ec7a29d5.svg",
		"name": "jwt.io",
		"url": "https://jwt.io/"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-15-441dd14fd1.svg",
		"name": "passport.js",
		"url": "http://passportjs.org/"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-16-49dfa8a7cd.svg",
		"name": "limitd",
		"url": "https://github.com/limitd/limitd/"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-17-a418d7d3b5.svg",
		"name": "sharelock",
		"url": "https://sharelock.io/"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-19-7554f375d8.svg",
		"name": "webtask",
		"url": "https://webtask.io/"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-cxn-1550731d52.svg",
		"name": "cxn",
		"url": "https://github.com/auth0/cxn"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-retro-1d4e70f6b2.svg",
		"name": "Repo-supervisor",
		"url": "https://github.com/auth0/repo-supervisor"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-saml-c17a8cbc60.svg",
		"name": "SAML Decoder",
		"url": "http://samltool.io/"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-SimpleKeychain-511e48d88d.svg",
		"name": "SimpleKeychain",
		"url": "https://github.com/auth0/SimpleKeychain"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-open-a0e381182d.svg",
		"name": "OpenID Connect Playground",
		"url": "https://openidconnect.net/"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/data/resources.json
// module id = 1356
// module chunks = 0